export const CONTINUE_CREATION = 'CONTINUE_CREATION';
